import React from "react";

export default function Emails({emails}) {
    return emails && emails.map( ({email}, i) =>
            <div key={i} >
                <a href={`mailto:${email}`}>{email}</a>
            </div>)
}
